import { useState } from "react";
import { GA_ID, getConsent, setConsent, initAnalytics } from "@/lib/analytics";

export function CookieConsent() {
  const [choice, setChoice] = useState(getConsent());
  if (!GA_ID || choice) return null;

  const decide = (value) => {
    setConsent(value);
    setChoice(value);
    if (value === "granted") initAnalytics();
  };

  return (
    <div
      className="fixed inset-x-4 bottom-24 z-[55] mx-auto max-w-lg rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl lg:bottom-6"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
    >
      <p className="text-sm leading-relaxed text-slate-600">
        We use privacy-respecting analytics to understand how visitors use this site. Analytics load only with
        your consent.
      </p>
      <div className="mt-4 flex gap-3">
        <button
          type="button"
          data-testid="cookie-accept-btn"
          onClick={() => decide("granted")}
          className="min-h-[44px] flex-1 rounded-full bg-ember px-4 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-ember-dark"
        >
          Accept
        </button>
        <button
          type="button"
          data-testid="cookie-decline-btn"
          onClick={() => decide("declined")}
          className="min-h-[44px] flex-1 rounded-full border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors duration-200 hover:bg-slate-100"
        >
          Decline
        </button>
      </div>
    </div>
  );
}
